
const commonConfig = {
    ga4: process.env.REACT_APP_GA_4,
    home_url: process.env.REACT_APP_HOME_URL,
    google_api_key: process.env.REACT_APP_GOOGLE_API_KEY,
    authen: {
        sso_url: process.env.REACT_APP_AUTHEN_SSO_URL,
        client_id: process.env.REACT_APP_AUTHEN_CLIENT_ID,
        redirect_uri: process.env.REACT_APP_AUTHEN_REDIRECT_URI,
        grant_type: process.env.REACT_APP_AUTHEN_GRANT_TYPE,
        length: process.env.REACT_APP_AUTHEN_LENGTH,
        api: {
            host_url: process.env.REACT_APP_AUTHEN_API_HOST_URL,
        },
        leela: {
            host_url: process.env.REACT_APP_AUTHEN_LEELA_URL,
        }
    },
    questions:{
        normal_question: 15,
        questions: 5,
        std_questions: 10,
        custom_questions: 5
    },
    upload_resume: {
        x_api_key: process.env.REACT_APP_UPLOAD_RESUME_X_API_KEY,
        base_url : process.env.REACT_APP_UPLOAD_RESUME_URL,
        lambda_url: process.env.REACT_APP_LAMBDA_URL
    },
    api:{
        url: process.env.REACT_APP_API_URL
    },
    quiz:{
        url: process.env.REACT_APP_QUIZ_API_URL
    },
    skills:{
        url: process.env.REACT_APP_SKILLS_BASE_URL,
        x_api_key: process.env.REACT_APP_SKILLS_X_API_KEY
    },
    share:{
        url: process.env.REACT_APP_INTERVIEW_URL
    }
 };
 
 
 // Generate final config by merging the common config with any environment-specific overrides
 const getConfig = () => {
     return {
         ...commonConfig
     };
 };
 
 const config = getConfig();
 
 export default config;
 